<template>
    <div class="project-stats">
        <div v-if="lang == 'de'">
            Mit den gewählten Filtereinstellungen wurden
            <strong class="count">{{ stats.projects.matches }}</strong> Projekt(e)
            von insgesamt <strong class="total">{{ stats.projects.total }}</strong>
            gefunden.
        </div>
        <div v-else>
            <p class="fst-italic">
                Note: A large part of the information is currently only available in German. In the course of the
                update the contents should also be provided in English.
            </p>
            <p>
                With the selected filter settings,
                <strong class="count">{{ stats.projects.matches }}</strong> project(s)
                out of <strong class="total">{{ stats.projects.total }}</strong>
                were found. 
            </p>
        </div>
    </div>
</template>


<script>
import { currentLang } from './AppUtils'

export default {
    props: {
        stats: {
            type: Object,
            default: () => ({
                projects: {
                    matches: 0,
                    total: null,
                }
            })
        }
    },
    data() {
        return {
            lang: currentLang()
        }
    }
}
</script>